'use client';

import { Box, Stack } from '@mui/material';
import { Starfield } from './components/starfield/starfield';

export function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <Box position="relative" width="100%" sx={{ overflowX: 'hidden' }}>
      {/* Background comes from starfield */}
      {<Starfield />}
      <Stack
        justifyContent="flex-start"
        flexGrow={1}
        direction="column"
        pb={4}
        alignItems="stretch"
        width="100%"
        sx={{
          gap: 0,
          '& > *': {
            width: '100%',
          },
        }}
        zIndex={150}
        position="relative"
      >
        {children}
      </Stack>
    </Box>
  );
}
